import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Radio, Row, Select, Space, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import dayjs from 'dayjs';
import StatusComponent from '../../globalComponents/StatusComponent';
import useExpenseReportAPI from '../apis/expenseReportAPI';
import BreadCumbNav from '../../globalComponents/BreadCumbNav';


const ExpenseReportChanges = () => {
  const { expenseReport, employees } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(expenseReport.summary ? expenseReport.summary : '');
  const { create, update } = useExpenseReportAPI();
  

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['summary'] = name;
    data.accounting_date = new Date(data.accounting_date);
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    // create(data, success);
    console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['summary'] = name;
    data.accounting_date = new Date(data.accounting_date);
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    // update(expenseReport.seo, data, success);
    console.log(data);
  };


  
  useEffect(() => {
    EventEmitter.subscribe('expensereport', data => {
      navigate('/expense/expense-reports/'+data);
    });

    EventEmitter.subscribe('createreportfromexpense', data => {
      console.log(data);
    })

    return () => {
      EventEmitter.unsubscribe('expensereport');
      EventEmitter.unsubscribe('createreportfromexpense');
    }
  },[])

  // useEffect(() => {
  //   if (costCenter.expense_account_id) {
  //     form.setFieldValue('expense_account_id', costCenter.expense_account_id);
  //     form.setFieldValue('total_amount', costCenter.cost_price.$numberDecimal);
  //   }
  // },[costCenter])

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
        <BreadCumbNav />
          {/* <h3 className='font-bold'>
            <Link to={'/expense/expense-reports'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Expense Reports</Link> / {params.action}
          </h3> */}
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ expenseReport.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          <Tooltip title='Update' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<RxUpdate />}
            />
          </Tooltip>
        </div>
        {/* {deliveryRegion.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>} */}
      </div>
      <div className='flex justify-between items-center bg-white'>
        <Flex gap={2}>
          <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn ms-1' onClick={()=> {}}>ATTACH RECIEPT</Button>
          <Button size='small' type='text' className='font-semibold text-[#189aa0] ms-1' onClick={()=> {}}>CREATE REPORT</Button>
        </Flex>
        <StatusComponent name='EXPENSES' formValue={expenseReport} />
      </div>
      <div className='mt-5 p-3 bg-white shadow'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          placeholder="Expense Report Summary"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 6 }}
          labelWrap={true}
          initialValues={expenseReport.seo ? {...expenseReport, total_amount: expenseReport.total_amount.$numberDecimal, accounting_date: dayjs(expenseReport.accounting_date, 'YYYY-MM-DD')} : {accounting_date: dayjs(), paid_by: 'company' }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Employee' name='employee_id' className='font-semibold text-gray-800 mb-1' >
                <Select options={employees.map(employee => ({value: employee.id, label: employee.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Paid By' name='paid_by' className='font-semibold text-gray-800 mb-1' >
                <Input type='text' className='input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Petty Cash' name='is_petty_cash' className='font-semibold text-gray-800 mb-1' valuePropName='checked'>
                <Checkbox />
              </Form.Item>
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Manager' name='manager_id' className='font-semibold text-gray-800 mb-1' >
                <Select options={employees.map(employee => ({value: employee.id, label: employee.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Accounting Date' name='accounting_date' className='font-semibold text-gray-800 mb-1' >
                <DatePicker className='input-outline-none w-full font-normal'/>
              </Form.Item>
              {/* <Form.Item label='Account' name='expense_account_id' className='font-semibold text-gray-800 mb-1' >
                <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='font-normal'/>
              </Form.Item> */}
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}

export default ExpenseReportChanges;